import languageJSON from '../language.json'
import store from "@/store";

export const isPermission = name => {
    if (name) {
        name = name.split('.')

        const permission = store.state.userPermissions
        return permission[name[0]] ? permission[name[0]].includes(name[1]) : false
    }

    return true
}

export const getSystemSetting = name => {
    const settings = store.state.systemSettings
    return settings[name]
}

export const nameToSlug = (name) => {
    return name.split(' ').join('_').toLowerCase()
}

export const srtValidFormat = (name) => {
    return name.split('_').join(' ')
}

export const getLanguages = (language) => {
    if (!language) {
        const n = []
        for (const key in languageJSON) {
            n.push(languageJSON[key])
        }
        return n
    }

    if (!languageJSON[language.toLowerCase()]) {
        return languageJSON['t1 native']
    }

    return languageJSON[language.toLowerCase()]
}

export const search = (list, query) => {
    for (const obj in query) {
        if (query[obj] === null) {
            delete query[obj]
        }
    }
    return list.filter(item => Object.keys(query).every(key => {
        if (Array.isArray(item[key])){
            return item[key].some(domain => domain === query[key])
        } else if (typeof item[key] === 'number') {
            return item[key] === +query[key]
        }
        return item[key] === query[key]
    }))
}

export const searchInArr = (list, query) => {
    return list.filter(item => Object.keys(query).every(key => {
        if (item[key]) {
            return item[key].includes(query[key])
        }
    }))
}

export const download = (text, name, type) => {
    const a = document.createElement("a")
    a.classList.add('download_link')
    document.body.appendChild(a)
    a.style = "display: none"

    const blob = new Blob([text], {type}),
        url = window.URL.createObjectURL(blob)
    a.href = url
    a.download = name
    a.click()
    window.URL.revokeObjectURL(url)
    a.remove('download_link')
}

export const copy = copyData => {
    try {
        const id = "mycustom-clipboard-textarea-hidden-id";
        let existsTextarea = document.getElementById(id);
        const textarea = document.createElement("textarea");
        textarea.id = id;
        textarea.style.position = 'fixed';
        textarea.style.top = 0;
        textarea.style.left = 0;
        textarea.style.width = '1px';
        textarea.style.height = '1px';
        textarea.style.padding = 0;
        textarea.style.border = 'none';
        textarea.style.outline = 'none';
        textarea.style.boxShadow = 'none';
        textarea.style.background = 'transparent';
        document.querySelector("body").appendChild(textarea);

        existsTextarea = document.getElementById(id);
        existsTextarea.value = copyData;
        existsTextarea.select();

        document.execCommand('copy');

        textarea.remove(id)
        return true
    } catch (e) {
        return false
    }
}

export const createDate = date => {
    return new Date(date).toLocaleString('ru').split(',')[0].split('.').reverse().join('-')
}

export const strUpp = (str) => {
    return srtValidFormat(str[0].toUpperCase() + str.slice(1));
}
